import { SDrawer, SDrawerOrModal, SGeneralForms } from "shj-components";
import { trimStr } from "@/utils/data.ts";
import { useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash-es";
import { seatIpConfigSave, seatIpConfigUpdate } from "@/services/crmTool.ts";
import { message } from "antd";

interface IAddOrEditProps {
  open?: boolean
  title?: string
  reload?: (values?: object, res?: any) => void
  onClose?: (values?: object) => void
  setOpen?: (open: boolean) => void
  onReload?: (values?: object) => void
  record?: any
}


export const AddOrEdit: React.FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const { record, open, setOpen, onReload } = props

  const formRef = useRef<any>()
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    formRef.current?.onFormRef().resetFields()
    !isEmpty(record) && formRef.current?.onFormRef()?.setFieldsValue(record)
  }, [record]);

  const onSubmit = () => {
    formRef.current?.onFormRef().validateFields().then(values => {
      setBtnLoading(true)
      const values_ = {
        ...values,
      }
      const apiUrl = values.id ? seatIpConfigUpdate : seatIpConfigSave
      apiUrl(values_).then((res: any) => {
        message.success(res.message || '操作成功');
        setOpen?.(false)
        onReload?.();
      }).finally(() => {
        setBtnLoading(false)
      })
    })
  }

  return (
    <SDrawer
      title={(record.id ? '编辑' : '新增')}
      open={open}
      onClose={() => setOpen?.(false)}
      onCancel={() => setOpen?.(false)}
      loading={btnLoading}
      onSubmit={onSubmit}
      destroyOnClose
    >
      <SGeneralForms
        ref={formRef}
        layout={'vertical'}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '通道名称',
                name: 'name',
                required: true,
                rules: [{ required: true, message: '通道名称不能为空' }],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 20,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('name', trimStr(e.target.value))
                }
              },
              {
                label: '通道地址',
                name: 'ip',
                required: true,
                rules: [{ required: true, message: '通道地址不能为空' }],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 200,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('ip', trimStr(e.target.value))
                }
              },
              {
                label: 'appid',
                name: 'appid',
                required: true,
                rules: [{ required: true, message: 'appid不能为空' }],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 200,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('appid', trimStr(e.target.value))
                }
              },
              {
                label: '密钥',
                name: 'secretKey',
                required: true,
                rules: [{ required: true, message: '密钥不能为空' }],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 200,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('secretKey', trimStr(e.target.value))
                }
              },
            ],
          },
        ]}
      />
    </SDrawer>
  )
}